/* ================================================
   Newgarden — Seguimiento de pedido
   order-tracking.js — traducciones inyectadas desde Liquid
   ================================================ */

(function () {
  'use strict';

  /* ── Config inyectada desde Liquid ──────────────
     window.__OT_CFG__ = { apiUrl, contactUrl, orderPrefix, t: { ... } }
  ─────────────────────────────────────────────── */
  const CFG = window.__OT_CFG__ || {};
  const API_URL      = CFG.apiUrl     || '';
  const CONTACT_URL  = CFG.contactUrl || '/pages/contacto';
  const ORDER_PREFIX = CFG.orderPrefix || '';
  const T            = CFG.t || {};

  /* Traducciones con fallbacks seguros */
  const STATUS_MAP   = T.statuses   || {};
  /* Fallbacks en inglés: solo si Liquid no inyectó t.* (evita mezclar idiomas p. ej. UI DE + errores ES) */
  const TIMELINE     = T.timeline   || ['Order received', 'Preparing', 'On the way', 'Delivered'];
  const ERRORS_DEFAULT = {
    NOT_FOUND:     "We couldn't find an order with those details.",
    INVALID_INPUT: 'The information entered is not valid.',
    RATE_LIMIT:    'Too many attempts. Please wait a moment before trying again.',
    NETWORK:       'Something went wrong. Please try again in a few minutes.',
  };
  const ERRORS = Object.assign({}, ERRORS_DEFAULT, T.errors || {});
  const CARRIER_TTL  = T.carrierTitle || 'Carrier';
  const TRACKING_BTN = T.trackingBtn  || 'View full tracking';
  const TRACKING_SOON = T.trackingSoon || 'Tracking number will be available shortly.';
  const ITEMS_LABEL  = T.itemsLabel   || 'Items';
  const BACK_TXT     = T.back         || 'Back';

  /* ── Paso activo del timeline (0-3) ──────────── */
  function getTimelineStep(status) {
    switch (status) {
      case 'DELIVERED':                                    return 3;
      case 'OUT_FOR_DELIVERY':                             return 2;
      case 'IN_TRANSIT': case 'FULFILLED': case 'SHIPPED':
      case 'PARTIALLY_FULFILLED': case 'ATTEMPTED_DELIVERY':
      case 'LABEL_PRINTED': case 'LABEL_PURCHASED':        return 2;
      default:                                             return 1;
    }
  }

  /* ── DOM refs ────────────────────────────────── */
  const formSection = document.getElementById('ot-form-section');
  const formEl      = document.getElementById('ot-form');
  const inputOrder  = document.getElementById('ot-order-number');
  const inputEmail  = document.getElementById('ot-email');
  const submitBtn   = document.getElementById('ot-submit');
  const skeletonEl  = document.getElementById('ot-skeleton');
  const resultEl    = document.getElementById('ot-result');
  const errorEl     = document.getElementById('ot-error');
  const liveRegion  = document.getElementById('ot-live');

  if (!formEl) return;

  /* ── Poner el título de transportista en el HTML ── */
  const carrierTitleEl = document.getElementById('ot-carrier-title');
  if (carrierTitleEl) carrierTitleEl.textContent = CARRIER_TTL;

  /* ── Auto-uppercase del nº de pedido ─────────── */
  inputOrder.addEventListener('input', function () {
    const sel = this.selectionStart;
    this.value = this.value.toUpperCase();
    this.setSelectionRange(sel, sel);
  });

  /* ── Pre-rellenar desde URL params ───────────── */
  (function checkUrlParams() {
    const p = new URLSearchParams(window.location.search);
    const o = p.get('order') || p.get('pedido') || '';
    const e = p.get('email') || '';
    if (o) {
      inputOrder.value = o.toUpperCase();
      if (e) { inputEmail.value = e; setTimeout(doSearch, 250); }
    }
  })();

  /* ── Submit ──────────────────────────────────── */
  formEl.addEventListener('submit', function (e) { e.preventDefault(); doSearch(); });

  /* ── Volver ──────────────────────────────────── */
  document.querySelectorAll('.ot-back-btn, .ot-error-back').forEach(function (b) {
    b.addEventListener('click', showForm);
  });

  /* ── Colapsable artículos ─────────────────────── */
  const itemsToggle = document.getElementById('ot-items-toggle');
  const itemsBody   = document.getElementById('ot-items-body');
  if (itemsToggle && itemsBody) {
    itemsToggle.addEventListener('click', function () {
      const exp = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!exp));
      itemsBody.classList.toggle('ot-visible', !exp);
    });
  }

  /* ── Búsqueda principal ──────────────────────── */
  async function doSearch() {
    const rawOrder = (inputOrder.value || '').trim().toUpperCase();
    const email    = (inputEmail.value  || '').trim().toLowerCase();

    if (!rawOrder || !email) {
      if (!rawOrder) highlightError(inputOrder);
      if (!email)    highlightError(inputEmail);
      announce(ERRORS.INVALID_INPUT);
      return;
    }
    if (!isValidEmail(email)) {
      highlightError(inputEmail);
      announce(ERRORS.INVALID_INPUT);
      return;
    }

    const orderName = normalizeOrderName(rawOrder);
    if (!String(API_URL || '').trim()) {
      showError(ERRORS.NETWORK, 'NETWORK');
      return;
    }

    showSkeleton();
    setSubmitLoading(true);

    try {
      const res  = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ orderName, email }),
      });
      const data = await res.json();

      if (!res.ok || !data.success) {
        const code = data?.error || 'NETWORK';
        showError(getErrorMsg(code, res.status), code);
      } else {
        renderResult(data.order);
      }
    } catch (_) {
      showError(getErrorMsg('NETWORK'), 'NETWORK');
    } finally {
      setSubmitLoading(false);
    }
  }

  /* ── Renderizar resultado ────────────────────── */
  function renderResult(order) {
    const statusInfo = STATUS_MAP[order.status] || { label: order.status, color: 'gray' };
    const step       = getTimelineStep(order.status);
    const ff         = order.fulfillments && order.fulfillments[0];

    /* Cabecera */
    document.getElementById('ot-result-name').textContent = order.name;
    document.getElementById('ot-result-date').textContent = formatDate(order.createdAt);

    /* Badge */
    const badgeEl = document.getElementById('ot-status-badge');
    badgeEl.className = 'ot-badge ot-badge--' + statusInfo.color;
    badgeEl.innerHTML = '<span class="ot-badge-dot"></span>' + esc(statusInfo.label);

    /* Timeline */
    renderTimeline(step);

    /* Transportista */
    const carrierSection = document.getElementById('ot-carrier-section');
    if (ff) {
      document.getElementById('ot-carrier-name').textContent   = ff.carrier || '—';
      document.getElementById('ot-carrier-number').textContent = ff.trackingNumber || '—';
      const trackWrap = document.getElementById('ot-tracking-wrap');
      if (ff.trackingUrl) {
        trackWrap.innerHTML =
          '<a href="' + escAttr(ff.trackingUrl) + '" target="_blank" rel="noopener noreferrer" class="ot-tracking-btn">' +
          iconExternal() + esc(TRACKING_BTN) + '</a>';
      } else {
        trackWrap.innerHTML = '<p class="ot-tracking-soon">' + esc(TRACKING_SOON) + '</p>';
      }
      carrierSection.style.display = '';
    } else {
      carrierSection.style.display = 'none';
    }

    /* Artículos */
    renderItems(order.items || []);

    showResult();
    announce(order.name + ' — ' + statusInfo.label);
  }

  function renderTimeline(activeStep) {
    const iconDone    = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    const iconActive  = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/></svg>';
    const iconPending = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/></svg>';

    const tlEl = document.getElementById('ot-timeline');
    tlEl.innerHTML = '';

    TIMELINE.forEach(function (label, i) {
      const isDone   = i < activeStep;
      const isActive = i === activeStep;
      const cls  = isDone ? 'ot-tl-done' : isActive ? 'ot-tl-active' : 'ot-tl-pending';
      const icon = isDone ? iconDone : isActive ? iconActive : iconPending;
      const el   = document.createElement('div');
      el.className = 'ot-timeline-step ' + cls;
      el.setAttribute('role', 'listitem');
      el.innerHTML =
        '<div class="ot-tl-icon-wrap" aria-hidden="true">' + icon + '</div>' +
        '<div class="ot-tl-content"><div class="ot-tl-label">' + esc(label) + '</div></div>';
      tlEl.appendChild(el);
    });
  }

  function renderItems(items) {
    const body  = document.getElementById('ot-items-body');
    const label = document.getElementById('ot-items-count-label');
    if (label) label.textContent = ITEMS_LABEL + ' (' + items.length + ')';

    const iconBox =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>';

    body.innerHTML = items.map(function (item) {
      const img = item.imageUrl
        ? '<img class="ot-item-img" src="' + escAttr(item.imageUrl) + '" alt="' + escAttr(item.title) + '" loading="lazy">'
        : '<div class="ot-item-img-placeholder" aria-hidden="true">' + iconBox + '</div>';

      const inner = img +
        '<span class="ot-item-title">' + esc(item.title) + '</span>' +
        '<span class="ot-item-qty">× ' + esc(String(item.quantity)) + '</span>';

      // Si hay URL de producto, envolver en <a>; si no, en <div>
      if (item.productUrl) {
        return '<a class="ot-item" href="' + escAttr(item.productUrl) + '">' + inner + '</a>';
      }
      return '<div class="ot-item">' + inner + '</div>';
    }).join('');
  }

  /* ── Estados UI ──────────────────────────────── */
  function showSkeleton() {
    formSection.style.display = 'none';
    skeletonEl.classList.add('ot-visible');
    resultEl.classList.remove('ot-visible');
    errorEl.classList.remove('ot-visible');
  }
  function showResult() {
    formSection.style.display = 'none';
    skeletonEl.classList.remove('ot-visible');
    resultEl.classList.add('ot-visible');
    errorEl.classList.remove('ot-visible');
    resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function showError(msg, code) {
    formSection.style.display = 'none';
    skeletonEl.classList.remove('ot-visible');
    resultEl.classList.remove('ot-visible');
    errorEl.classList.add('ot-visible');
    const msgEl = document.getElementById('ot-error-msg');
    if (msgEl) {
      const isNotFound = code === 'NOT_FOUND' || msg === ERRORS.NOT_FOUND;
      if (isNotFound) {
        msgEl.innerHTML = formatNotFoundMessage(msg);
      } else {
        msgEl.textContent = msg;
      }
    }
    announce(msg);
  }
  function showForm() {
    formSection.style.display = '';
    skeletonEl.classList.remove('ot-visible');
    resultEl.classList.remove('ot-visible');
    errorEl.classList.remove('ot-visible');
    inputOrder.focus();
  }
  function setSubmitLoading(loading) {
    submitBtn.disabled = loading;
    const t = document.getElementById('ot-submit-text');
    const s = document.getElementById('ot-submit-spinner');
    if (t) t.style.display = loading ? 'none' : '';
    if (s) s.style.display = loading ? '' : 'none';
  }

  /* ── Helpers ─────────────────────────────────── */
  function normalizeOrderName(raw) {
    // Si ya tiene letras al inicio → dejarlo tal cual
    if (/^[A-Z]{1,3}\d+$/.test(raw)) return raw;
    // Solo números + prefijo configurado para esta tienda
    if (/^\d+$/.test(raw) && ORDER_PREFIX) return ORDER_PREFIX + raw;
    return raw;
  }
  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function formatDate(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString(document.documentElement.lang || 'es', { day: '2-digit', month: 'long', year: 'numeric' }); }
    catch (_) { return iso; }
  }
  function highlightError(input) {
    input.classList.add('ot-input--error');
    input.addEventListener('input', function () { this.classList.remove('ot-input--error'); }, { once: true });
  }
  function announce(msg) {
    if (liveRegion) { liveRegion.textContent = ''; liveRegion.textContent = msg; }
  }
  function getErrorMsg(code, status) {
    if (status === 429 || code === 'RATE_LIMIT') return ERRORS.RATE_LIMIT;
    if (code === 'NOT_FOUND') return ERRORS.NOT_FOUND;
    if (code === 'INVALID_INPUT') return ERRORS.INVALID_INPUT;
    return ERRORS.NETWORK;
  }
  function preventWidow(text) {
    const clean = String(text || '').trim();
    return esc(clean).replace(/\s+(\S+)\s*$/, '&nbsp;$1');
  }
  function formatNotFoundMessage(msg) {
    const raw = String(msg || '').trim();
    if (!raw) return '';
    const parts = raw.split('. ');
    const first = (parts.shift() || '').replace(/\.+$/, '');
    const rest = parts.join('. ');
    const firstHtml = '<span class="ot-error-highlight">' + preventWidow(first) + '.</span>';
    if (!rest) return firstHtml;
    return firstHtml + '<span class="ot-error-subline">' + preventWidow(rest) + '</span>';
  }
  function esc(s)      { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function escAttr(s)  { return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function iconExternal() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
  }

})();
